module.exports = __webpack_public_path__ + "static/media/ico-linea-de-atencion-inact.bd1e1312.svg";